import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 px-0 my-4 font-body font-size-16 font-weight-default text-primary-black" }
const _hoisted_2 = { class: "px-0" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "title-4 text-grey-800" }
const _hoisted_5 = { class: "search-main px-lg-3 d-flex flex-column my-4" }
const _hoisted_6 = { class: "d-flex w-100 px-3 pb-3" }
const _hoisted_7 = {
  key: 0,
  class: "col-12 px-0 ox-md-3"
}

import { computed, ComputedRef, watch } from "vue"
//import store from "@/vue/planning/store/store"

// components
import Form from "@/vue/planning/components/search/form.vue"; /// OLD way to search in the APP, after the new search block is implemented, delete this one and the legacy code
import Banners from "@/vue/planning/components/common/banners.vue";
import Packages from "@/vue/planning/components/search/packages.vue";
import FlightOriginDropdown from '@/vue/planning/components/search/flight/flightOriginDropDown.vue';
import FlightForm from "@/vue/planning/components/search/flight/flightForm.vue"
import GeneralForm from "@/vue/planning/components/search/generalForm.vue"
// config

// computed
import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes"
import availableFlightPackCodes from "@/vue/planning/computed/availableFlightPackCodes"

import screenType from "@/vue/planning/computed/screenType"
import packagesToDisplay from "@/vue/planning/computed/packagesToDisplay"
import DataFilter from "@/vue/planning/components/search/DataFilter.vue"
import useLocale from "@/vue/composables/useLocale";

import { useStore } from "@/vue/planning/store/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'search',
  setup(__props) {

const store = useStore();
const locale = useLocale();

// computed
const stepNum: ComputedRef<string> = computed(()=>{
    if (availableTransportPackCodes.value.length > 0 && store.state.screenType === "desktop") return "2. "
    return "1. "
})


watch(
    () => store.getters.variants,
    () => store.dispatch("ensurePrestationsPreselected")
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(stepNum.value) + _toDisplayString(_unref(store).state.content.planner_chooseFormula), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_unref(screenType) === 'mobile')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(Packages, { packagesToDisplay: _unref(packagesToDisplay) }, null, 8, ["packagesToDisplay"]),
              (_unref(availableFlightPackCodes).length && _unref(locale) === 'en_US')
                ? (_openBlock(), _createBlock(FlightOriginDropdown, {
                    key: 0,
                    class: "px-3"
                  }))
                : _createCommentVNode("", true),
              _createVNode(Form, { class: "mt-3" })
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(availableFlightPackCodes).length && _unref(locale) === 'en_US')
                ? (_openBlock(), _createBlock(FlightForm, { key: 0 }))
                : (_openBlock(), _createBlock(GeneralForm, { key: 1 }))
            ], 64)),
        _createElementVNode("div", _hoisted_6, [
          (_unref(store).getters.prestations[0])
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(Banners, {
                  lihe: _unref(store).state.liheData,
                  startDate: _unref(store).getters.prestations[0].variants[0].startDate
                }, null, 8, ["lihe", "startDate"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})